import { z } from "zod";
import {
    AudioSettingsSliceSchema,
    DEFAULT_AUDIO_SETTINGS,
    type AudioSettingsSlice,
} from "../../schemas/slices/AudioSettingsSliceSchema";

const AUDIO_SETTINGS_STORAGE_KEY = "pbtg.audio-settings";
const LegacyAudioSettingsSchema = z.object({
    musicEnabled: z.boolean(),
    soundEffectsEnabled: z.boolean(),
});

export function readStoredAudioSettings(): AudioSettingsSlice {
    try {
        const storedSettings = window.localStorage.getItem(
            AUDIO_SETTINGS_STORAGE_KEY,
        );
        if (storedSettings === null) return DEFAULT_AUDIO_SETTINGS;

        const parsedSettings: unknown = JSON.parse(storedSettings);
        const currentSettings =
            AudioSettingsSliceSchema.safeParse(parsedSettings);
        if (currentSettings.success) return currentSettings.data;

        const legacySettings = LegacyAudioSettingsSchema.parse(parsedSettings);
        return AudioSettingsSliceSchema.parse({
            slotMachineMusicEnabled: legacySettings.musicEnabled,
            careerMusicEnabled: legacySettings.musicEnabled,
            soundEffectsEnabled: legacySettings.soundEffectsEnabled,
        });
    } catch {
        return DEFAULT_AUDIO_SETTINGS;
    }
}

export function writeStoredAudioSettings(
    audioSettings: AudioSettingsSlice,
): void {
    try {
        const validatedSettings = AudioSettingsSliceSchema.parse(audioSettings);
        window.localStorage.setItem(
            AUDIO_SETTINGS_STORAGE_KEY,
            JSON.stringify(validatedSettings),
        );
    } catch {
        // Audio preferences remain available for this session when storage is
        // blocked or unavailable.
    }
}
